<div class="profile-container">
  <div class="nav-bar">
    <div class="nav-bar-title">داشبورد</div>
    <div
      class="nav-bar-setting img-holder"
      (click)="goToSetting()"
      id="setting-box"
    >
      <img src="assets/profile/setting.svg" />
    </div>
  </div>
  <div *ngIf="dataIsReady" class="profile-holder">
    <div class="profile-top-holder" (click)="goToShop()">
      <img class="profile-top-card-icon" src="assets/profile/shop.png" />
      <div class="profile-top-title">فروشگاه</div>
      <div *ngIf="remainingSubscription !== 0" class="profile-top-description">
        {{ remainingSubscription }} روز از اشتراک شما باقی مانده
      </div>
      <div *ngIf="remainingSubscription === 0" class="profile-top-description">
        شما اشتراک ندارید
      </div>
      <img class="profile-card-more" src="assets/general/left-gray.svg" />
    </div>
    <!-- <div
      class="profile-top-holder"
      (click)="goToReferral()"
      style="border-bottom: 1px solid #cccccc"
    >
      <img
        class="profile-top-card-icon"
        src="assets/profile/referral-icon.png"
        style="width: 40px; height: 40px; top: 17px; right: 12px"
      />
      <div class="profile-top-title">دعوت دوستان</div>
      <div class="profile-top-description">
        با دعوت دوست خود ۱ هفته اشتراک رایگان بگیرید
      </div>
      <img class="profile-card-more" src="assets/general/left-gray.svg" />
    </div> -->
    <div class="profile-report-title">گزارش‌ها</div>
    <div class="profile-report-holder" id="reports-box">
      <div class="profile-report-card" (click)="goToDetail()">
        <img class="profile-card-icon" src="assets/general/calorie.png" />
        <div class="profile-card-title">کالری</div>
        <img
          *ngIf="!hasNoDiet"
          class="profile-report-card-more"
          src="assets/general/left-gray.svg"
        />
      </div>
      <div class="profile-report-line"></div>
      <div class="profile-report-card" (click)="goToBarChart()">
        <img
          class="profile-card-icon"
          style="width: 20px; right: 22px"
          src="assets/profile/water.png"
        />
        <div class="profile-card-title">آب</div>
        <img
          class="profile-report-card-more"
          src="assets/general/left-gray.svg"
        />
      </div>
      <div class="profile-report-line"></div>
      <div class="profile-report-card" (click)="goToLineChart()">
        <img class="profile-card-icon" src="assets/profile/weight.png" />
        <div class="profile-card-title">وزن</div>
        <img
          class="profile-report-card-more"
          src="assets/general/left-gray.svg"
        />
      </div>
    </div>
  </div>
</div>
